import React from "react";
import { Typography, Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const Iraab = ({ currentActivity, iraabAnswers }) => {
  const correctWords = currentActivity.Iraab.Value.split(" ");
  let allCorrect = true;

  correctWords.forEach((correctWord, index) => {
    const harakaatPattern = /[ًٌٍَُِْ]$/; // Arabic diacritics pattern
    const userWord = iraabAnswers[index] || "";

    if (!harakaatPattern.test(correctWord)) return; // Skip if no harakaat

    if (userWord.trim() !== correctWord.trim()) {
      allCorrect = false;
    }
  });

  return (
    <>
      {allCorrect ? (
        <>
          <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "green",
              marginTop: 1,
            }}
          >
            Correct
          </Typography>
        </>
      ) : (
        <>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <CancelIcon sx={{ fontSize: 40, color: "red" }} />
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "red",
              marginTop: 1,
              textAlign: "center",
            }}
          >
            Incorrect
          </Typography>

          {/* Show rationale only when incorrect */}
          {currentActivity.Iraab?.Rationale?.Text?.trim() ? (
            <Typography
              sx={{
                marginTop: 1,
                fontSize: "0.75rem",
                color: "text.secondary",
                padding: "8px",
                margin: "8px 0",
              }}
            >
              {`Rationale: ${currentActivity.Iraab.Rationale}`}
            </Typography>
          ) : currentActivity.Iraab?.Rationale?.ContentId ? (
            <Box
              sx={{
                marginTop: 1,
                fontSize: "0.75rem",
                color: "text.secondary",
                padding: "8px",
                margin: "8px 0",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
            >
              {/* You can replace this with your actual LessonComponent */}
              Showing lesson for content ID:{" "}
              {currentActivity.Iraab.Rationale.ContentId}
            </Box>
          ) : (
            <Typography
              sx={{
                fontSize: "0.9rem",
                fontStyle: "italic",
                color: "#999",
                marginTop: 1,
              }}
            >
              Rationale: Not available.
            </Typography>
          )}
        </>
      )}
    </>
  );
};

export default Iraab;
